module.exports = __webpack_public_path__ + "img/ohm-logo.43814d3b.jpg";